import { render } from "./TestSwiper.vue?vue&type=template&id=8e5b519a&scoped=true"
import script from "./TestSwiper.vue?vue&type=script&lang=js"
export * from "./TestSwiper.vue?vue&type=script&lang=js"

import "./TestSwiper.vue?vue&type=style&index=0&id=8e5b519a&scoped=true&lang=css"

import exportComponent from "/var/www/turkey-25/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e5b519a"]])

export default __exports__